import styled from 'styled-components'
import { colors } from '@monorepo/theme'

export const Separator = styled.hr`
  width: 100%;
  border-top: 0.5px solid ${colors.highlightGrey};
  margin: 0 auto;
`
